import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { phaseOn, type CycleData } from './cycle';
import { today } from './dates';

export const EMPTY_CYCLE: CycleData = { periods: [], days: {} };

export async function loadCycle(uid: string): Promise<CycleData> {
  const s = await getDoc(doc(db, 'users', uid, 'private', 'cycle'));
  return s.exists() ? ({ ...EMPTY_CYCLE, ...s.data() } as CycleData) : EMPTY_CYCLE;
}

/**
 * Share only the current phase (never the log) with the partner, and only when
 * the person has turned sharing on. Turning it off clears what the partner sees.
 */
export async function syncPhase(uid: string, duoId: string | undefined, data: CycleData, share: boolean): Promise<void> {
  if (!duoId) return;
  const ref = doc(db, 'duos', duoId, 'members', uid);
  const p = share ? phaseOn(data, today()) : null;
  await updateDoc(ref, {
    cyclePhase: p
      ? { phase: p.info.id, label: p.info.label, day: p.day, partnerHint: p.info.partnerHint, updatedAt: today() }
      : null,
  }).catch(() => undefined);
}
